<section class="card-auth-review">
  <div class="card-auth-review__panel">
    <h1>3DS authentication</h1>

    <p *ngIf="isLoading" class="card-auth-review__meta">Loading request...</p>
    <p *ngIf="!isLoading && errorMessage" class="card-auth-review__error">{{ errorMessage }}</p>

    <ng-container *ngIf="!isLoading && authentication">
      <div class="card-auth-review__status">
        <span class="card-auth-review__status-badge" [attr.data-status]="authentication.status">
          {{ statusLabel }}
        </span>
        <span *ngIf="authentication.expiresAt" class="card-auth-review__meta">
          Expires {{ authentication.expiresAt | date: 'dd MMM yyyy, HH:mm' }}
        </span>
      </div>

      <div class="card-auth-review__summary">
        <div>
          <span class="card-auth-review__label">Merchant</span>
          <strong>{{ authentication.merchant.name || 'Unknown merchant' }}</strong>
        </div>
        <div>
          <span class="card-auth-review__label">Amount</span>
          <strong>{{ authentication.transaction.amount }} {{ authentication.transaction.currency }}</strong>
        </div>
        <div>
          <span class="card-auth-review__label">Card</span>
          <strong>{{ authentication.card?.maskedPan || authentication.cardId }}</strong>
        </div>
        <div>
          <span class="card-auth-review__label">Requested</span>
          <strong>{{ authentication.transaction.creationDateTime | date: 'dd MMM yyyy, HH:mm' }}</strong>
        </div>
        <div *ngIf="authentication.merchant.city || authentication.merchant.country">
          <span class="card-auth-review__label">Location</span>
          <strong>{{ authentication.merchant.city || '' }} {{ authentication.merchant.country || '' }}</strong>
        </div>
        <div *ngIf="authentication.merchant.categoryCode">
          <span class="card-auth-review__label">Category code</span>
          <strong>{{ authentication.merchant.categoryCode }}</strong>
        </div>
      </div>

      <p *ngIf="isPending" class="card-auth-review__help">
        Review the payment details above and confirm whether you want to approve this 3DS request.
      </p>

      <p *ngIf="!isPending" class="card-auth-review__help">
        This 3DS request has already been processed. No further action is required.
      </p>

      <div *ngIf="isPending" class="card-auth-review__actions">
        <button type="button" class="card-auth-review__button card-auth-review__button--secondary" (click)="reject()" [disabled]="isSubmitting">
          Decline
        </button>
        <button type="button" class="card-auth-review__button" (click)="approve()" [disabled]="isSubmitting">
          Approve
        </button>
      </div>
    </ng-container>
  </div>
</section>
